/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { DocNode as ADF } from '@atlaskit/adf-schema/doc';
import { defaultSchema as schema } from '@atlaskit/adf-schema/schema-default';
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { WikiMarkupTransformer } from '@atlaskit/editor-wikimarkup-transformer';

export const convertAdfToWiki = (document: ADF): string => {
	try {
		const jsonTransformer = new JSONTransformer();
		const wikiMarkupTransformer = new WikiMarkupTransformer(schema);

		if (document === null || document === undefined) {
			return '';
		}

		return wikiMarkupTransformer.encode(jsonTransformer.parse(document));
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// We handle this state by disabling the option to export to markdown.
		return '';
	}
};

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const isAdfObject = (field: any): any => {
	return field && field.type === 'doc' && Array.isArray(field.content);
};
